import { createFileRoute } from '@tanstack/react-router';
import { NotaFiscalListagem } from '@/features/nfe/page/listagem/NotaFiscalListagem';

export const Route = createFileRoute('/a/nota-fiscal/')({
    component: NotaFiscalListagem,
});
